import { Pipe, PipeTransform, Inject } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import dayjs from '@shared/date/dayjs-bootstrap';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'calendarTime',
    pure: false,
    standalone: false
})
export class CalendarTimePipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private translate: TranslateService
  ) {
    dayjs.locale(this.locale);
  }

  transform(value: string | number | Date, formats?: Record<string, string>): string {
    const translations = this.translate.instant('SystemAdmin.Date.Calendar');
    return dayjs.tz(new Date(value)).calendar(null, {
      sameDay: translations.SameDay || '[Today at] h:mm:ss A', // The same day ( Today at 2:30:00 AM )
      nextDay: translations.NextDay || '[Tomorrow at] h:mm:ss A', // The next day ( Tomorrow at 2:30:00 AM )
      nextWeek: translations.NextWeek || 'dddd [at] h:mm:ss A', // The next week ( Sunday at 2:30:00 AM )
      lastDay: translations.LastDay || '[Yesterday at] h:mm:ss A', // The day before ( Yesterday at 2:30:00 AM )
      lastWeek: translations.LastWeek || '[Last] dddd [at] h:mm:ss A', // Last week ( Last Monday at 2:30:00 AM )
      sameElse: translations.SameElse || 'DD/MM/YYYY HH:mm:ss' // Everything else ( 17/10/2011 14:30:00 )
    });
  }
}
